import React from "react";
import { Alert, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface MedicalDisclaimerProps {
  style?: React.CSSProperties;
  className?: string;
}

export const MedicalDisclaimer: React.FC<MedicalDisclaimerProps> = ({ 
  style, 
  className 
}) => {
  return (
    <div
      style={{
        marginTop: "24px",
        padding: "12px 16px",
        backgroundColor: "#fafbfc",
        border: "1px solid #f1f3f4",
        borderRadius: "4px",
        textAlign: "center",
        ...style
      }}
      className={className}
    >
      <Text style={{ color: "#6a737d", fontSize: "12px", lineHeight: "1.4" }}>
        <InfoCircleOutlined style={{ marginRight: "6px", fontSize: "11px", opacity: 0.7 }} />
        CodePilot assists with ICD-10 identification but may make mistakes. 
        We recommend verifying codes with qualified medical staff before clinical or billing decisions.
      </Text>
    </div>
  );
}; 